module.exports = __webpack_public_path__ + "img/服务@2x.d884ec95.png";